const getters = {
  GET_SORT: (state) => state.sort,
  GET_DATE: (state) => state.date,
  GET_SEARCH: (state) => state.search,
  GET_LOGS: (state) => state.logs,
  GET_LOGS_LOADING: (state) => state.logsLoading,
  GET_LOGS_ERROR: (state) => state.logsError,
  GET_SELECTED_LOGS: (state) => state.selectedLogs,
  GET_CURRENT_TAB: (state) => state.currentTab,

  // Sticker transactions
  GET_STICKER_TRANSACTIONS: (state) => state.stickerTransactions,
  GET_STICKER_LOADING: (state) => state.stickerLoading,
  GET_STICKER_ERROR: (state) => state.stickerError,

  // Stripe transactions
  GET_STRIPE_TRANSACTIONS: (state) => state.stripeTransactions,
  GET_STRIPE_LOADING: (state) => state.stripeLoading,
  GET_STRIPE_ERROR: (state) => state.stripeError,

  // Benevity transactions
  GET_BENEVITY_TRANSACTIONS: (state) => state.benevityTransactions,
  GET_BENEVITY_LOADING: (state) => state.benevityLoading,
  GET_BENEVITY_ERROR: (state) => state.benevityError,

  // Benevity W2W Credit transactions
  GET_BENEVITY_W2W_TRANSACTIONS: (state) => state.benevityW2WCreditTransactions,
  GET_BENEVITY_W2W_LOADING: (state) => state.benevityW2WLoading,
  GET_BENEVITY_W2W_ERROR: (state) => state.benevityW2WError,

  // Computed getter to get current transaction data based on active tab
  GET_CURRENT_TRANSACTIONS: (state) => {
    switch (state.currentTab) {
      case 'sticker':
        return state.stickerTransactions;
      case 'stripe':
        return state.stripeTransactions;
      case 'benevity':
        return state.benevityTransactions;
      case 'benevity-w2w':
        return state.benevityW2WCreditTransactions;
      default:
        return state.stickerTransactions;
    }
  },

  // Computed getter to get current loading state based on active tab
  GET_CURRENT_LOADING: (state) => {
    switch (state.currentTab) {
      case 'sticker':
        return state.stickerLoading;
      case 'stripe':
        return state.stripeLoading;
      case 'benevity':
        return state.benevityLoading;
      case 'benevity-w2w':
        return state.benevityW2WLoading;
      default:
        return state.stickerLoading;
    }
  },

  // Computed getter to get current error state based on active tab
  GET_CURRENT_ERROR: (state) => {
    switch (state.currentTab) {
      case 'sticker':
        return state.stickerError;
      case 'stripe':
        return state.stripeError;
      case 'benevity':
        return state.benevityError;
      case 'benevity-w2w':
        return state.benevityW2WError;
      default:
        return state.stickerError;
    }
  },

  // Get filtered transactions based on search and date filters
  GET_FILTERED_TRANSACTIONS: (state, getters) => {
    let transactions = getters.GET_CURRENT_TRANSACTIONS;

    // Apply date filter
    if (state.date && Array.isArray(state.date) && state.date.length === 2) {
      const [startDate, endDate] = state.date.map((d) => new Date(d));
      transactions = transactions.filter((log) => {
        const logDate = new Date(log.date);
        return logDate >= startDate && logDate <= endDate;
      });
    }

    // Apply search filter
    if (state.search) {
      const searchTerm = state.search.toLowerCase();
      transactions = transactions.filter((log) => {
        return Object.keys(log).some((key) => {
          const value = log[key];

          if (typeof value === 'string' && value.toLowerCase().includes(searchTerm)) {
            return true;
          }

          if (value instanceof Date || !isNaN(Date.parse(value))) {
            const formattedDate = new Date(value).toLocaleString();
            return (
              formattedDate.toLowerCase().includes(searchTerm)
              || new Date(value).toDateString().toLowerCase().includes(searchTerm)
              || new Date(value).toLocaleDateString('en-US').toLowerCase().includes(searchTerm)
              || new Date(value).toLocaleDateString().toLowerCase().includes(searchTerm)
            );
          }

          return false;
        });
      });
    }

    return transactions;
  },
};

export default getters;
